export default "__VITE_ASSET__B9y8E5mi__"